import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import * as routes from 'constants/routes';
import { auth, db } from 'firedb';


// import 'adminlte-reactjs/public/dist/css/AdminLTE.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

const err_user_not_admin = 'user/user-not-admin';

const init_state = {
	email  : '',
	password  : '',
	error  : null,
    errorHappens : false,
};

const updateByPropertyName = (propertyName, value) => () => ({
	[propertyName]: value,
});

var InputEmailError = props => {
    return (
        <div>
            <span align="center" className="help-block">{props.message}</span>
        </div>
    )
};

class SignInPage extends Component {
	constructor(props) {
        // console.log("### #### #### #### #### #### #### ##### ###");
        // console.log("# Welcome to sign in page!");
        // console.log("# This is development for dropcard company.");
        // console.log("# You can testing this service with :");
        // console.log("# email: demo@dropcard.ru;");
        // console.log("# passwd: thisIsSimplePass");
        // console.log("### #### #### #### #### #### #### ##### ###");
        // console.log(authUser);
        // console.log("");

		super(props);
		this.state = {...init_state};
	}

    componentWillMount() {

    }

	onSubmit = (event) => {
        const { email, password, } = this.state;
        const { history, } = this.props;

        auth.doSignInWithEmailAndPassword(email, password)
            .then((snapshot) => {
                // check user's "role"
                db.ref('admin/' + auth.currentUser().uid).once('value').then(snapshot => {
                    if (snapshot.val() != null) {
                        this.setState(() => ({ ...init_state }));
                        history.push(routes.HOME);
                    } else {
                        this.setState(updateByPropertyName('error', err_user_not_admin));
                        this.setState(updateByPropertyName('errorHappens', true));
                        auth.doSignOut();
                    }
                })
                
            })
            .catch(error => {
                this.setState(updateByPropertyName('error', error.code));
                this.setState(updateByPropertyName('errorHappens', true));
        });		
	}

    onPasswordInputKeyPress = (event) => {
        if(event.key === 'Enter') {
            this.onSubmit(event);   
        }
    }
	
	render() {
		var { email, password, error, errorHappens, } = this.state;

        var inputEmailErrorMessage = "";
        var inputPasswordErrorMessage = ""; 
        var inputSignInErrorClass = "";

        if (error) {
            inputSignInErrorClass = "has-error";

            switch (error) {
                case err_user_not_admin:
                    inputEmailErrorMessage = "Пользователь не является администратором компании";
                    break;

                case 'auth/user-disabled':
                    inputEmailErrorMessage = "Данная учетная запись была заблокирована";
                    break;

                case 'auth/user-not-found': 
                    inputEmailErrorMessage = "Пользователь с такой почтой не найден";
                    if (errorHappens) {
                        // password = "";
                        this.signinInputEmail.focus();
                    }
                    break;

                case 'auth/invalid-email': 
                    inputEmailErrorMessage = "Неправильный почтовый адрес";
                    if (errorHappens) {
                        // password = "";    
                        this.signinInputEmail.focus();
                    }
                    break;

                case 'auth/wrong-password': 
                    inputPasswordErrorMessage = "Неверный пароль";
                    if (errorHappens) {
                        password = "";    
                        this.signinInputPasswd.focus();
                    }
                    break;

                default:
                    inputPasswordErrorMessage = "Введен неверный пароль";
                    break;
            };

        }


		return (            
        <div className="content container-sign">

        <div className="login-box-body">
            <p className="h2 text-center">НАКОПИ!</p>

            <p className="login-box-msg text-muted">Система лояльности для кассовых систем Эвотор</p>

            <div>
                <div className={"form-group has-feedback " + inputSignInErrorClass} >
                    <input id="eml" type="email" className="form-control" placeholder="Почта"   
                        value={email}  ref={ (signinInputEmail) => { this.signinInputEmail = signinInputEmail }}
                        onChange={event => {this.setState(updateByPropertyName('errorHappens', false));
                                            this.setState(updateByPropertyName('email', event.target.value));
                        }}
                        onKeyPress={event => { if(event.key === 'Enter') { this.signinInputPasswd.focus(); }} }
                        autoFocus required />

                    {error ? <InputEmailError message={inputEmailErrorMessage} /> : ''}
                </div>

                <div className={"form-group has-feedback " + inputSignInErrorClass} >
                    <input id="password" type="password" className="form-control" placeholder="Пароль" name="passwd" 
                        value={password} ref={ (signinInputPasswd) => { this.signinInputPasswd = signinInputPasswd }}
                        onChange={event => {this.setState(updateByPropertyName('errorHappens', false));
                                            this.setState(updateByPropertyName('password', event.target.value));
                        }}
                        onKeyPress={this.onPasswordInputKeyPress}
                        required />

                    {error ? <InputEmailError message={inputPasswordErrorMessage} /> : ''}                                      
                </div>

                    <div className="col-xs-12 no-padding login-page-bttn" >
                        <button  
                            type="submit"
                            className="btn btn-primary btn-block btn-flat" 

                            onClick={this.onSubmit} 
                        >
                            Войти
                        </button>
                        
                    </div>
                    {/*<div className="col-xs-12 no-padding login-page-bttn" >*/}
                        {/*<a href="/signup">*/}
                            {/*<button type="submit" className="btn btn-primary btn-block btn-flat">Регистрация</button>*/}
                        {/*</a>*/}
                    {/*</div>*/}

                    <div className="col-xs-12 no-padding login-page-bttn">
                        <a href="/pw-forget" className="login-page-i-forgive-passwd" >Я забыл пароль</a><br />
                    </div>
            </div>


        </div>
    
    </div>
    
// </div>
// </div>
// 
		)
	}

}

export default withRouter(SignInPage);
// export default SignInPage;





// WEBPACK FOOTER //
// ./src/components/SignIn/SignIn.jsx